import { InputPercent } from '@bedrock/components';
import React, { useEffect, useRef } from 'react';
import Decimal from 'decimal.js';


function SInputPercent(props: React.ComponentProps<typeof InputPercent>) {
  const { value, onChange, ...restProps } = props;

  const localValue = useRef(value);

  useEffect(() => {
    if (restProps.valueType === 'number' && typeof value === 'string' && !['', undefined, null].includes(value)) {
      localValue.current = +value;
    } else {
      localValue.current = value;
    }
  }, [value, restProps.valueType]);

  return <InputPercent
    {...restProps}
    value={localValue.current}
    onChange={(v) => {
      localValue.current = v;
    }}
    onBlur={(e) => {
      const blurValue = e.target.value;
      if (['', undefined, null].includes(blurValue)) {
        onChange?.(undefined);
      } else {
        if (restProps.valueType === 'number') {
          onChange?.(new Decimal(blurValue).div(100).toNumber());
        } else {
          onChange?.(blurValue);
        }
      }
    }}
  />;
}

export default SInputPercent;
